export interface Chapter {
  id: number;
  number: number;
  title: string;
  date: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  chapters: Chapter[];
  status: string;
  updateDate: string;
  featured: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "星辰坠落之夜",
    author: "金秀雅",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20couple%20under%20a%20starry%20night%20sky%20with%20soft%20romantic%20atmosphere%2C%20delicate%20lineart%2C%20warm%20tones%2C%20dreamy%20watercolor%20background%2C%20clean%20composition%20on%20white%20background&width=400&height=560&seq=comic-01&orientation=portrait",
    description: "在星光璀璨的夜空下，两个灵魂因命运交织而相遇。她是一个普通的大学生，却意外发现自己拥有穿越时空的能力。每当夜幕降临，星辰便会指引她前往不同的时代。在一次意外中，她邂逅了来自高丽王朝的王子，一段跨越千年的爱情故事就此展开。他们能否战胜时间的阻隔，守护彼此的爱恋？",
    category: "romance",
    tags: ["穿越", "浪漫", "古风"],
    rating: 4.8,
    views: 1250000,
    chapters: [
      { id: 1, number: 1, title: "命运的相遇", date: "2026-07-28" },
      { id: 2, number: 2, title: "时空之门", date: "2026-07-25" },
      { id: 3, number: 3, title: "初入高丽", date: "2026-07-22" },
      { id: 4, number: 4, title: "王子的秘密", date: "2026-07-19" },
      { id: 5, number: 5, title: "禁忌之恋", date: "2026-07-16" },
      { id: 6, number: 6, title: "危机四伏", date: "2026-07-13" },
    ],
    status: "连载中",
    updateDate: "2026-07-28",
    featured: true,
  },
  {
    id: 2,
    title: "暗夜猎魔人",
    author: "朴正宇",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20cover%20illustration%20of%20a%20dark%20fantasy%20demon%20hunter%20with%20sword%20standing%20in%20a%20gothic%20cityscape%2C%20dramatic%20lighting%2C%20red%20and%20black%20color%20palette%2C%20clean%20composition%20on%20dark%20background&width=400&height=560&seq=comic-02&orientation=portrait",
    description: "在一个妖魔横行的世界，人类建立了名为「猎魔公会」的组织来对抗黑暗势力。主角韩宇辰是公会中最年轻的S级猎魔人，拥有操控暗影的独特能力。当一股前所未有的邪恶力量开始觉醒，整个世界的命运都压在了他的肩上。友情、背叛、牺牲，一场史诗级的猎魔之战即将拉开帷幕。",
    category: "fantasy",
    tags: ["战斗", "奇幻", "热血"],
    rating: 4.7,
    views: 2100000,
    chapters: [
      { id: 7, number: 1, title: "猎魔人的诞生", date: "2026-08-01" },
      { id: 8, number: 2, title: "暗影觉醒", date: "2026-07-29" },
      { id: 9, number: 3, title: "第一次任务", date: "2026-07-26" },
      { id: 10, number: 4, title: "亡灵之城", date: "2026-07-23" },
      { id: 11, number: 5, title: "神秘盟友", date: "2026-07-20" },
    ],
    status: "连载中",
    updateDate: "2026-08-01",
    featured: true,
  },
  {
    id: 3,
    title: "我的恶魔室友",
    author: "李恩智",
    cover: "https://readdy.ai/api/search-image?query=A%20cute%20Korean%20manhwa%20style%20illustration%20of%20a%20demon%20boy%20and%20a%20normal%20girl%20living%20together%20in%20a%20modern%20apartment%2C%20comedic%20slice%20of%20life%20vibe%2C%20warm%20color%20palette%2C%20clean%20composition&width=400&height=560&seq=comic-03&orientation=portrait",
    description: "平凡大学生林晓晓的新学期迎来了一个意想不到的转折——她的新室友竟然是个从魔界被流放的恶魔王子！这个恶魔不仅不会做饭、不懂人间规矩，还总是惹出一堆麻烦。但随着相处的日子一天天过去，晓晓发现这个「恶魔」其实有着一颗比任何人都温暖的心。一段搞笑又温馨的同居生活，就此开始！",
    category: "comedy",
    tags: ["搞笑", "日常", "奇幻"],
    rating: 4.6,
    views: 890000,
    chapters: [
      { id: 12, number: 1, title: "恶魔降临", date: "2026-07-30" },
      { id: 13, number: 2, title: "同居第一天", date: "2026-07-27" },
      { id: 14, number: 3, title: "人间的规则", date: "2026-07-24" },
      { id: 15, number: 4, title: "意外的温柔", date: "2026-07-21" },
    ],
    status: "连载中",
    updateDate: "2026-07-30",
    featured: true,
  },
  {
    id: 4,
    title: "第七夜",
    author: "崔敏浩",
    cover: "https://readdy.ai/api/search-image?query=A%20suspenseful%20Korean%20manhwa%20cover%20illustration%20of%20a%20detective%20looking%20at%20evidence%20in%20a%20dimly%20lit%20room%20with%20mysterious%20shadows%2C%20thriller%20atmosphere%2C%20muted%20colors%2C%20tense%20mood&width=400&height=560&seq=comic-04&orientation=portrait",
    description: "首尔连续发生七起离奇失踪案件，每个案件都发生在第七天的夜晚。刑警姜道贤接手此案后，发现所有失踪者都与一个神秘的地下组织有关联。随着调查的深入，他发现自己也一步步陷入了危险之中。真相远比想象中更加可怕——第七夜的谜底，究竟隐藏着什么？",
    category: "mystery",
    tags: ["悬疑", "推理", "犯罪"],
    rating: 4.9,
    views: 1560000,
    chapters: [
      { id: 16, number: 1, title: "第一个失踪者", date: "2026-08-02" },
      { id: 17, number: 2, title: "线索浮现", date: "2026-07-30" },
      { id: 18, number: 3, title: "地下世界", date: "2026-07-27" },
      { id: 19, number: 4, title: "第四夜", date: "2026-07-24" },
      { id: 20, number: 5, title: "真相的碎片", date: "2026-07-21" },
      { id: 21, number: 6, title: "暗流涌动", date: "2026-07-18" },
    ],
    status: "连载中",
    updateDate: "2026-08-02",
    featured: true,
  },
  {
    id: 5,
    title: "赤焰骑士团",
    author: "郑勇基",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20action%20manhwa%20cover%20illustration%20of%20a%20knight%20in%20flaming%20red%20armor%20wielding%20a%20giant%20sword%20against%20a%20battlefield%20background%2C%20epic%20fantasy%20style%2C%20warm%20fire%20tones&width=400&height=560&seq=comic-05&orientation=portrait",
    description: "在剑与魔法的世界中，「赤焰骑士团」是王国最精锐的部队。出身贫民窟的少年路西安，凭借惊人的天赋和不懈的努力，成为了骑士团历史上最年轻的成员。然而，一场突如其来的背叛让骑士团陷入了前所未有的危机。路西安必须带领残存的同伴，揭开隐藏在王国背后的巨大阴谋。",
    category: "action",
    tags: ["战斗", "奇幻", "冒险"],
    rating: 4.5,
    views: 980000,
    chapters: [
      { id: 22, number: 1, title: "贫民窟的少年", date: "2026-07-31" },
      { id: 23, number: 2, title: "骑士选拔", date: "2026-07-28" },
      { id: 24, number: 3, title: "荣耀与使命", date: "2026-07-25" },
      { id: 25, number: 4, title: "背叛之夜", date: "2026-07-22" },
    ],
    status: "连载中",
    updateDate: "2026-07-31",
    featured: false,
  },
  {
    id: 6,
    title: "幽灵教室",
    author: "尹素贞",
    cover: "https://readdy.ai/api/search-image?query=A%20creepy%20Korean%20horror%20manhwa%20cover%20illustration%20of%20a%20haunted%20school%20classroom%20with%20ghostly%20figures%20in%20the%20dark%2C%20eerie%20atmosphere%2C%20pale%20blue%20and%20gray%20tones%2C%20scary%20mood&width=400&height=560&seq=comic-06&orientation=portrait",
    description: "废弃多年的松林高中，流传着「午夜教室会出现幽灵」的传说。一群好奇心旺盛的学生决定在毕业前夜前往探险，却遭遇了超乎想象的恐怖事件。教室的钟声在午夜响起，尘封多年的真相逐渐浮出水面——三十年前，这里究竟发生了什么？",
    category: "horror",
    tags: ["恐怖", "校园", "灵异"],
    rating: 4.4,
    views: 720000,
    chapters: [
      { id: 26, number: 1, title: "校园传说", date: "2026-07-29" },
      { id: 27, number: 2, title: "午夜探险", date: "2026-07-26" },
      { id: 28, number: 3, title: "第一声钟响", date: "2026-07-23" },
    ],
    status: "连载中",
    updateDate: "2026-07-29",
    featured: false,
  },
  {
    id: 7,
    title: "咖啡与猫与日常",
    author: "韩智恩",
    cover: "https://readdy.ai/api/search-image?query=A%20cozy%20Korean%20slice%20of%20life%20manhwa%20cover%20illustration%20of%20a%20girl%20drinking%20coffee%20with%20a%20cute%20cat%20in%20a%20warm%20cafe%2C%20soft%20pastel%20colors%2C%20relaxing%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=comic-07&orientation=portrait",
    description: "辞去高压工作后，苏敏在京畿道的小巷里开了一家名为「午后」的猫咪咖啡馆。每天与三只性格迥异的猫咪——傲娇的拿铁、贪吃的摩卡、慵懒的卡布奇诺一起生活。在这里，她遇到了形形色色的客人，倾听了他们各自的故事。这是一个关于治愈、温暖与慢生活的日常故事。",
    category: "slice-of-life",
    tags: ["日常", "治愈", "温馨"],
    rating: 4.7,
    views: 650000,
    chapters: [
      { id: 29, number: 1, title: "新的开始", date: "2026-07-27" },
      { id: 30, number: 2, title: "第一位客人", date: "2026-07-24" },
      { id: 31, number: 3, title: "拿铁的心事", date: "2026-07-21" },
    ],
    status: "连载中",
    updateDate: "2026-07-27",
    featured: false,
  },
  {
    id: 8,
    title: "月光花园",
    author: "安宰贤",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20BL%20manhwa%20cover%20illustration%20of%20two%20handsome%20men%20in%20a%20moonlit%20garden%20with%20flowers%2C%20romantic%20atmosphere%2C%20soft%20moonlight%2C%20delicate%20style%2C%20elegant%20composition&width=400&height=560&seq=comic-08&orientation=portrait",
    description: "著名的园艺设计师尹瑞俊在月光花园项目中，遇到了性格完全相反的年轻建筑师金泰亨。瑞俊追求自然与随性，泰亨则执着于完美与秩序。两个截然不同的灵魂在建造花园的过程中不断碰撞、摩擦，却也在不知不觉中走进了彼此的心。在月光洒满的花园里，爱情如花般悄然绽放。",
    category: "bl",
    tags: ["耽美", "治愈", "都市"],
    rating: 4.6,
    views: 880000,
    chapters: [
      { id: 32, number: 1, title: "月光下的邂逅", date: "2026-07-28" },
      { id: 33, number: 2, title: "第一次争执", date: "2026-07-25" },
      { id: 34, number: 3, title: "花园里的秘密", date: "2026-07-22" },
      { id: 35, number: 4, title: "心动的瞬间", date: "2026-07-19" },
    ],
    status: "连载中",
    updateDate: "2026-07-28",
    featured: true,
  },
  {
    id: 9,
    title: "重生之绝世剑神",
    author: "金泰秀",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20isekai%20manhwa%20cover%20illustration%20of%20a%20swordsman%20in%20a%20fantasy%20world%20with%20magical%20aura%2C%20reincarnation%20theme%2C%20dramatic%20pose%2C%20golden%20and%20white%20color%20palette&width=400&height=560&seq=comic-09&orientation=portrait",
    description: "武术大师李青云在渡劫失败后，意外重生到了异世界。这个世界的武道文明极度落后，他前世所学的绝世剑法在这里成为了无人能及的神技。凭借前世的记忆和经验，他从一个无名小卒一步步登上了大陆的巅峰。然而，在他追求最强之路上，一个关于世界真相的惊人秘密正在浮出水面。",
    category: "isekai",
    tags: ["穿越", "战斗", "升级"],
    rating: 4.3,
    views: 1350000,
    chapters: [
      { id: 36, number: 1, title: "渡劫失败", date: "2026-08-01" },
      { id: 37, number: 2, title: "异世界觉醒", date: "2026-07-29" },
      { id: 38, number: 3, title: "天才的起点", date: "2026-07-26" },
      { id: 39, number: 4, title: "初露锋芒", date: "2026-07-23" },
      { id: 40, number: 5, title: "学院风云", date: "2026-07-20" },
    ],
    status: "连载中",
    updateDate: "2026-08-01",
    featured: false,
  },
  {
    id: 10,
    title: "深海之约",
    author: "朴海娜",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20fantasy%20manhwa%20cover%20illustration%20of%20a%20mermaid%20and%20a%20human%20man%20meeting%20underwater%20with%20bubbles%20and%20light%20rays%2C%20magical%20atmosphere%2C%20blue%20and%20coral%20tones&width=400&height=560&seq=comic-10&orientation=portrait",
    description: "海洋生物学研究生郑夏琳在济州岛进行海底考察时，意外发现了一个隐藏在深海中的神秘国度。那里居住着拥有与人类相似外貌的人鱼族。她与人鱼族的王子阿克莱斯相识相知，两个来自不同世界的灵魂坠入爱河。但两个世界的隔阂、族人的反对、以及海洋污染带来的危机，让这段跨越种族的爱情充满了挑战。",
    category: "romance",
    tags: ["奇幻", "浪漫", "人鱼"],
    rating: 4.8,
    views: 1100000,
    chapters: [
      { id: 41, number: 1, title: "海底的秘密", date: "2026-07-31" },
      { id: 42, number: 2, title: "人鱼国度", date: "2026-07-28" },
      { id: 43, number: 3, title: "两个世界", date: "2026-07-25" },
      { id: 44, number: 4, title: "禁忌之约", date: "2026-07-22" },
    ],
    status: "连载中",
    updateDate: "2026-07-31",
    featured: false,
  },
  {
    id: 11,
    title: "魔王学院的不适格者",
    author: "李贤宇",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20action%20manhwa%20cover%20illustration%20of%20a%20student%20with%20dark%20magical%20powers%20in%20a%20magical%20academy%20setting%2C%20dramatic%20lighting%2C%20purple%20and%20black%20magic%20effects&width=400&height=560&seq=comic-11&orientation=portrait",
    description: "在培养勇者的「圣光学院」中，有一个被所有人视为废物的少年——因为他体内流淌着的是魔王之血。夏宇翔不仅要忍受同学的歧视和老师的偏见，还要隐藏自己日益觉醒的魔王力量。当黑暗势力开始入侵学院，这个被所有人看不起的「不适格者」，或许才是拯救一切的关键。",
    category: "fantasy",
    tags: ["学院", "魔法", "逆袭"],
    rating: 4.5,
    views: 1780000,
    chapters: [
      { id: 45, number: 1, title: "魔王之子", date: "2026-08-02" },
      { id: 46, number: 2, title: "不屑的目光", date: "2026-07-30" },
      { id: 47, number: 3, title: "力量觉醒", date: "2026-07-27" },
      { id: 48, number: 4, title: "第一次证明", date: "2026-07-24" },
      { id: 49, number: 5, title: "黑暗来袭", date: "2026-07-21" },
    ],
    status: "连载中",
    updateDate: "2026-08-02",
    featured: true,
  },
  {
    id: 12,
    title: "办公室罗曼史",
    author: "崔秀英",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20office%20manhwa%20cover%20illustration%20of%20a%20couple%20sharing%20a%20secret%20moment%20in%20a%20modern%20office%2C%20warm%20lighting%2C%20professional%20yet%20romantic%20vibe%2C%20clean%20composition&width=400&height=560&seq=comic-12&orientation=portrait",
    description: "广告公司的策划总监李秀贤，和一个意外调到她部门的新人设计师产生了微妙的情感。公司严禁办公室恋情，两人只能在工作之余小心翼翼地维系这段关系。但感情就像一份精美的策划案，越是隐藏，越是无法控制。职场、爱情、梦想，一场甜蜜又现实的办公室罗曼史。",
    category: "romance",
    tags: ["都市", "职场", "恋爱"],
    rating: 4.4,
    views: 760000,
    chapters: [
      { id: 50, number: 1, title: "新人报到", date: "2026-07-28" },
      { id: 51, number: 2, title: "初见倾心", date: "2026-07-25" },
      { id: 52, number: 3, title: "秘密开始", date: "2026-07-22" },
    ],
    status: "连载中",
    updateDate: "2026-07-28",
    featured: false,
  },
  {
    id: 13,
    title: "武林高手在现代",
    author: "郑泰元",
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20Korean%20comedy%20manhwa%20cover%20illustration%20of%20a%20martial%20artist%20in%20traditional%20clothing%20confused%20in%20a%20modern%20city%2C%20comedic%20expression%2C%20bright%20colors&width=400&height=560&seq=comic-13&orientation=portrait",
    description: "武林至尊白无尘在闭关百年后醒来，却发现自己穿越到了21世纪的首尔。手机？地铁？外卖？这个古代的最强者在现代社会变成了一个彻头彻尾的「小白」。闹出的笑话接连不断，但他惊人的武功也在城市中引起了不小的轰动。古今碰撞，笑料百出的都市武林喜剧！",
    category: "comedy",
    tags: ["搞笑", "穿越", "武侠"],
    rating: 4.6,
    views: 920000,
    chapters: [
      { id: 53, number: 1, title: "百年觉醒", date: "2026-07-30" },
      { id: 54, number: 2, title: "首尔大冒险", date: "2026-07-27" },
      { id: 55, number: 3, title: "地铁惊魂", date: "2026-07-24" },
      { id: 56, number: 4, title: "外卖初体验", date: "2026-07-21" },
    ],
    status: "连载中",
    updateDate: "2026-07-30",
    featured: false,
  },
  {
    id: 14,
    title: "迷雾山庄",
    author: "尹秀雅",
    cover: "https://readdy.ai/api/search-image?query=A%20mystery%20Korean%20manhwa%20cover%20illustration%20of%20an%20old%20mansion%20shrouded%20in%20fog%20with%20a%20group%20of%20people%20looking%20suspicious%2C%20dark%20and%20moody%20atmosphere&width=400&height=560&seq=comic-14&orientation=portrait",
    description: "十位身份各异的陌生人收到了一封神秘的邀请函，被召集到一座与世隔绝的山庄中。暴风雪切断了所有通往外界道路的同时，第一位死者出现了。每个人都有自己的秘密，每个人都可能是凶手。在这座迷雾笼罩的山庄里，一场致命的「游戏」正在上演。",
    category: "mystery",
    tags: ["悬疑", "推理", "惊悚"],
    rating: 4.7,
    views: 830000,
    chapters: [
      { id: 57, number: 1, title: "神秘邀请函", date: "2026-08-01" },
      { id: 58, number: 2, title: "山庄集结", date: "2026-07-29" },
      { id: 59, number: 3, title: "暴风雪之夜", date: "2026-07-26" },
      { id: 60, number: 4, title: "第一具尸体", date: "2026-07-23" },
    ],
    status: "连载中",
    updateDate: "2026-08-01",
    featured: false,
  },
  {
    id: 15,
    title: "校草守护计划",
    author: "金敏雅",
    cover: "https://readdy.ai/api/search-image?query=A%20cute%20Korean%20school%20romance%20manhwa%20cover%20illustration%20of%20a%20shy%20girl%20and%20a%20popular%20boy%20in%20school%20uniform%2C%20cherry%20blossom%20background%2C%20sweet%20youthful%20atmosphere&width=400&height=560&seq=comic-15&orientation=portrait",
    description: "学校里最受欢迎的校草韩智浩，实际上有一个不为人知的秘密——他极度社恐！为了维持完美的校草形象，他不得不请性格活泼的同桌柳多恩帮忙扮演他的「经纪人」。随着两人的关系越来越密切，一段青涩又搞笑的校园恋爱故事悄然展开。",
    category: "romance",
    tags: ["校园", "恋爱", "搞笑"],
    rating: 4.5,
    views: 680000,
    chapters: [
      { id: 61, number: 1, title: "校草的秘密", date: "2026-07-29" },
      { id: 62, number: 2, title: "经纪人的诞生", date: "2026-07-26" },
      { id: 63, number: 3, title: "第一次约会", date: "2026-07-23" },
    ],
    status: "连载中",
    updateDate: "2026-07-29",
    featured: false,
  },
  {
    id: 16,
    title: "废柴逆袭系统",
    author: "宋在赫",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20isekai%20system%20manhwa%20cover%20illustration%20of%20a%20loser%20who%20suddenly%20gets%20a%20game-like%20status%20window%20with%20stats%2C%20bright%20and%20energetic%20style&width=400&height=560&seq=comic-16&orientation=portrait",
    description: "万年废柴大学生徐东旭在某天醒来后，眼前突然出现了一个只有游戏中才能看到的「系统面板」。任务、技能、属性、商店……他的人生从此变成了一场可以「升级」的游戏。曾经被人看不起的废柴，开始在现实中一路逆袭——但这一切背后，似乎隐藏着更大的秘密。",
    category: "isekai",
    tags: ["系统", "逆袭", "搞笑"],
    rating: 4.4,
    views: 1050000,
    chapters: [
      { id: 64, number: 1, title: "系统降临", date: "2026-07-31" },
      { id: 65, number: 2, title: "第一个任务", date: "2026-07-28" },
      { id: 66, number: 3, title: "初显身手", date: "2026-07-25" },
      { id: 67, number: 4, title: "隐藏的真相", date: "2026-07-22" },
    ],
    status: "连载中",
    updateDate: "2026-07-31",
    featured: false,
  },
];